"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const giftbag = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 26 26",
    "aria-labelledby": (title ? `title-giftbag` : '') + (description ? ` desc-giftbag` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-giftbag"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-giftbag"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "ulta_gift_bag",
    transform: "translate(1, 1)",
    stroke: "#000000",
    strokeWidth: "1.5"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.5661,5.64649263 L20.2854421,5.64649263 C20.68806,5.64649263 21.0769938,5.78752329 21.3795766,6.04312859 C21.6821593,6.29874524 21.8777469,6.65153754 21.9298879,7.03568889 L23.9860349,22.1976765 C24.016588,22.4228535 23.9968877,22.6516623 23.9281136,22.8688944 C23.8593394,23.0861266 23.7432609,23.2867883 23.5874278,23.4573734 C23.4317127,23.6279585 23.2399,23.7646082 23.0248481,23.8582428 C22.8097961,23.9517638 22.5764594,24 22.3404095,24 L8.47114934,24",
    id: "Path"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.72253244,5.64649263 L3.71454874,5.64649263 C3.31188367,5.64649263 2.92298523,5.78752329 2.62040249,6.04312859 C2.31781976,6.29874524 2.12222037,6.65153754 2.070103,7.03568889 L0.0139559887,22.1976765 C-0.0165971998,22.4228535 0.00315030508,22.6516623 0.0718772843,22.8688944 C0.14061606,23.0861266 0.256741769,23.2867883 0.412515844,23.4573734 C0.568289919,23.6279585 0.760114397,23.7646082 0.975166376,23.8582428 C1.19021836,23.9517638 1.42355506,24 1.65958139,24 L15.5288179,24",
    id: "Path"
  }), /*#__PURE__*/_react.default.createElement("line", {
    x1: "11.9240135",
    y1: "14.9577395",
    x2: "16.0716973",
    y2: "18.9482738",
    id: "Path"
  }), /*#__PURE__*/_react.default.createElement("line", {
    x1: "7.77637691",
    y1: "18.9482738",
    x2: "11.9240135",
    y2: "14.9577395",
    id: "Path"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.9240135,14.9577399 L15.5255149,11.4926936 C15.7708841,11.2562805 16.072995,11.0818365 16.4051872,10.9846836 C16.7372614,10.8875306 17.0892719,10.8706197 17.4298397,10.9356531 C17.7704074,11.0006866 18.0889156,11.145508 18.3574062,11.3574058 C18.6257788,11.5691902 18.8357582,11.8414681 18.9687059,12.1500649 C19.1016535,12.4586617 19.1533226,12.7940436 19.1192304,13.1264746 C19.0852562,13.4587922 18.9664645,13.7780576 18.7734722,14.0557834 C18.5805978,14.3333956 18.3194211,14.5610695 18.0131814,14.7183755 C17.7068238,14.8756816 17.3649584,14.9579665 17.0177845,14.9577399 L11.9240135,14.9577399 Z",
    id: "Path"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.9240135,14.9577395 L8.3225476,11.4915586 C8.07724914,11.2551456 7.77512647,11.0807015 7.44295787,10.9835486 C7.11078927,10.8863957 6.75882597,10.8694847 6.41829358,10.9345181 C6.0777494,10.9995516 5.75913508,11.144373 5.4907035,11.3562709 C5.22226012,11.5680552 5.01229247,11.8403331 4.879392,12.1489299 C4.74649153,12.4575267 4.69477524,12.7929086 4.72883202,13.1253397 C4.762877,13.4576572 4.88164515,13.7769227 5.07459031,14.0546484 C5.26753546,14.3322607 5.52872393,14.5599345 5.83497541,14.7172406 C6.14122689,14.8745466 6.48309229,14.9568315 6.83027797,14.9566045 L11.9240135,14.9577395 Z",
    id: "Path"
  }), /*#__PURE__*/_react.default.createElement("line", {
    x1: "3.34671902",
    y1: "5.64649263",
    x2: "10.6098725",
    y2: "5.64649263",
    id: "Path"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.2442792,5.22088103 L17.2442792,3.25285299 C17.2525368,2.828592 17.1729098,2.40699817 17.0098808,2.01271158 C16.8469698,1.618425 16.6038419,1.25935635 16.294889,0.956491136 C15.986054,0.653625922 15.6175283,0.413047546 15.2107816,0.248818216 C14.8041529,0.0845888869 14.3675608,0 13.926486,0 C13.4854112,0 13.0488191,0.0845888869 12.6421904,0.248818216 C12.2354437,0.413047546 11.866918,0.653625922 11.5579651,0.956491136 C11.2491302,1.25935635 11.0060023,1.618425 10.8430913,2.01271158 C10.6800623,2.40699817 10.6003173,2.828592 10.6086929,3.25285299 L10.6086929,5.22088103",
    id: "Path"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.93793132,0.595901639 C7.48294834,0.887905246 7.11003428,1.28357649 6.8523612,1.74770878 C6.59468811,2.21185241 6.46025408,2.73006575 6.4609942,3.25625788 L6.4609942,5.64649263",
    id: "Path"
  }))));
};
var _default = exports.default = giftbag;